import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import SidImg1 from '../../images/testimonial/img-4.jpg'
// import SidImg2 from '../../images/testimonial/img-5.jpg'
// import client1 from '../../images/testimonial/client/1.jpg'
// import client2 from '../../images/testimonial/client/2.jpg'

import Quote from '../../images/testimonial/quote-2.svg'

const testimonials = [
    {
        id: '01',
        img: 'https://res.cloudinary.com/dexvxngzg/image/upload/v1764569647/1.66dc300f9ee9a0c9c407_eb8mmr.jpg',
        Des: "QHB next level flexitarian yr bicycle rights waistcoat bit austin tofu-daa glossier whatever scenester snack wave literally can shaman grained.",
        Title: 'Leslie Alexander',
        Sub: "Marketing Coordinator",
    },
    {
        id: '02',
        img: `https://res.cloudinary.com/dexvxngzg/image/upload/v1764569647/1.66dc300f9ee9a0c9c407_eb8mmr.jpgg`,
        Des: "QHB next level flexitarian yr bicycle rights waistcoat bit austin tofu-daa glossier whatever scenester snack wave literally can shaman grained.",
        Title: 'John Abraham',
        Sub: "WEb Developer",
    },



]


const TestimonialS3 = (props) => {

    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    dots: true,
                    arrows: false,
                }
            },
        ]
    }
    return (
        <section className="wpo-testimonial-section-s4">
            <div className="wraper">
                <div className="testimonial-left  scroll-text-animation" data-animation="fade_from_left">
                        <Slider {...settings} className="testimonial-slider">
                            {testimonials.slice(0, 2).map((testimonial, item) => (
                                <div className="item" key={item}>
                                    <div className="content">
                                        <div className="icon">
                                            <img src={Quote} alt="quote" />
                                        </div>
                                        <h3>“{testimonial.Des}”</h3>
                                        <div className="client-wrap">
                                            <div className="image">
                                                <img src={testimonial.img} alt="" />
                                            </div>
                                            <div className="text">
                                                <h4>{testimonial.Title}</h4>
                                                <span>{testimonial.Sub}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}

                        </Slider>
                    <div className="image">
                        <img src={`https://res.cloudinary.com/dexvxngzg/image/upload/v1764569647/img-4.c827467b6a9241bcf0e5_vpa61v.jpg`} alt="" />
                    </div>
                </div>
                <div className="testimonial-right scroll-text-animation" data-animation="fade_from_right">
                    <div className="image">
                        <img src={'https://res.cloudinary.com/dexvxngzg/image/upload/v1764569768/img-5.d6bbc341d2c5fe0ad008_1_fwhitl.jpg'} alt="" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TestimonialS3;